import React, { Fragment, useContext, useEffect, useState } from "react";
import { Container, Carousel, Spinner } from "react-bootstrap";
import ProductCard2 from "../ProductCard/ProductCard2";
import "../../App.css";
import "../ProductList/ProductList.css";
import { HiOutlineArrowNarrowLeft } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import "./categories.css";
import CompaniesSlider from "../Sliders/CompaniesSlider";
import Slider from "../Sliders/Slider";
import { getScreen } from "../../Actions/Screens";
import { refreshToken } from "../../Actions/Auth";
import { common_product_widget } from "../../Actions/Widgets";
import InfiniteScroll from "react-infinite-scroll-component";
import { getCatgoriesData } from "../../Actions/Categories";
import { BannerData, usersData } from "../../App";
import ErrorModal from "../Modals/ErrorModal";
import { Common_Event_Hit } from "../../Actions/UserEvents";
import BannerSlider from "../BannerRedirects/BannerSlider";

const Fmcg = ({ getProductListHeader }) => {
  let navigate = useNavigate();
  const [widgetsData, setWidgetsData] = useState();
  const [offersWidget, setOffersWidget] = useState();
  const [bannerWidget, setBannerWidget] = useState();
  const [productList, setProductList] = useState();
  const [productListNew, setProductListNew] = useState();
  const [bannerImages, setBannerImages] = useState([]);
  const [allProductList, setAllProductList] = useState();
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [manufacturers, setManufacturers] = useState();
  const [dataLength, setDataLength] = useState(0);
  const [skuData, setSkuData] = useState();
  const { setBannerData } = useContext(BannerData);
  const { setShowMaintenance } = useContext(usersData);
  const [errorModal, setErrorModal] = useState(false);
  const [homeShimmer, setHomeShimmer] = useState(false);
  const [manufShimmer, setManfShimmer] = useState(false);
  const [topSellShimmer, setTopSellShimmer] = useState(false);
  const [newlyAddShimmer, setNewlyAddShimmer] = useState(false);
  const [allShimmer, setAllShimer] = useState(false);

  const getAllProducts = () => {
    const params = {
      category: "FMCG",
      filterCondition: "all",
      page: page,
    };
    page === 0 && setAllShimer(true);
    let api = common_product_widget("home/v2/getMedicineByCategory", params);
    api
      .then((res) => {
        setAllShimer(false);
        let obj =
          allProductList && allProductList.medicinesResponsesList
            ? allProductList
            : { medicinesResponsesList: [] };
        if (res.data.data.medicinesResponsesList.length > 0) {
          obj.medicinesResponsesList.push(
            ...res.data.data.medicinesResponsesList,
          );
          setDataLength(obj.medicinesResponsesList.length);
        }

        setAllProductList(obj);
        if (res.data.data.size > 0 && obj.medicinesResponsesList.length < 10) {
          fetchMoreData();
        } else if (
          res.data.data.size > 0 &&
          res.data.data.medicinesResponsesList.length === 0
        ) {
          fetchMoreData();
        }

        if (res.data.data.size === 0) {
          setHasMore(false);
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          refreshToken().then((res) => {
            getAllProducts();
          });
        } else if (
          error?.response?.status === 502 ||
          error?.response?.status === 503 ||
          error?.response?.status === 504
        ) {
          setShowMaintenance({ status: true, apiData: error?.response });
        } else if (error?.response?.status === 500) {
          setErrorModal({
            show: true,
            apiData: error?.response,
            content: "Oops something went wrong !",
            tryAgain: function () {
              getAllProducts();
            },
          });
        } else {
          setErrorModal({
            show: true,
            apiData: error?.response,
            content: error?.response?.data?.error?.error
              ? error.response.data.error.error
              : "Something went wrong!",
            tryAgain: function () {
              getAllProducts();
            },
          });
        }
      });
  };

  const fetchMoreData = () => {
    setPage(+page + 1);
  };

  const getManufacturers = () => {
    setManfShimmer(true);
    common_product_widget("home/v2/company/viewAllCompaniesByCategory", {
      category: "FMCG",
    })
      .then((res) => {
        setManufacturers(res.data.data);
        setManfShimmer(false);
      })
      .catch((error) => {
        setManfShimmer(false);
        if (error?.response?.status === 401) {
          refreshToken().then(() => getManufacturers());
        } else if (
          error?.response?.status === 502 ||
          error?.response?.status === 503 ||
          error?.response?.status === 504
        ) {
          setShowMaintenance({ status: true, apiData: error?.response });
        }
      });
  };

  const getPopularProducts = () => {
    setTopSellShimmer(true);
    common_product_widget("home/v2/getMedicineByCategory", {
      category: "FMCG",
      filterCondition: "popular",
      page: 0,
    })
      .then((res) => {
        setProductList(res.data.data);
        setTopSellShimmer(false);
      })
      .catch((error) => {
        setTopSellShimmer(false);
        if (error?.response?.status === 401) {
          refreshToken().then(() => getPopularProducts());
        } else if (
          error?.response?.status === 502 ||
          error?.response?.status === 503 ||
          error?.response?.status === 504
        ) {
          setShowMaintenance({ status: true, apiData: error?.response });
        }
      });
  };

  const getNewProducts = () => {
    setNewlyAddShimmer(true);
    common_product_widget("home/v2/getMedicineByCategory", {
      category: "FMCG",
      filterCondition: "new",
      page: 0,
    })
      .then((res) => {
        setProductListNew(res.data.data);
        setNewlyAddShimmer(false);
      })
      .catch((error) => {
        setNewlyAddShimmer(false);
        if (error?.response?.status === 401) {
          refreshToken().then(() => getNewProducts());
        } else if (
          error?.response?.status === 502 ||
          error?.response?.status === 503 ||
          error?.response?.status === 504
        ) {
          setShowMaintenance({ status: true, apiData: error?.response });
        }
      });
  };

  const getSkuCount = () => {
    getCatgoriesData("CATEGORY_SKU_COUNT", { category: "FMCG" })
      .then((res) => {
        setSkuData(res.data.data);
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          refreshToken().then((res) => {
            getSkuCount();
          });
        } else if (
          error?.response?.status === 502 ||
          error?.response?.status === 503 ||
          error?.response?.status === 504
        ) {
          setShowMaintenance({ status: true, apiData: error?.response });
        } else if (error?.response?.status === 500) {
          setErrorModal({
            show: true,
            apiData: error?.response,
            content: "Oops something went wrong !",
            tryAgain: function () {
              getSkuCount();
            },
          });
        } else {
          setErrorModal({
            show: true,
            apiData: error?.response,
            content: error?.response?.data?.error?.error
              ? error.response.data.error.error
              : "Something went wrong!",
            tryAgain: function () {
              getSkuCount();
            },
          });
        }
      });
  };

  const homeBannerSlide = (event) => {
    localStorage.setItem(
      "currentScreenBannerData",
      JSON.stringify({ index: +event + 1, data: bannerWidget[event] }),
    );
  };

  useEffect(() => {
    let userData = localStorage.getItem("userData");
    localStorage.setItem("currentScreen", "food_screen");
    localStorage.removeItem("currentScreenBannerData");

    if (userData) {
      setHomeShimmer(true);
      const params = {
        retailerId: JSON.parse(userData).id,
        screenName: "food_screen",
      };

      let schemes_screen = () => {
        getScreen("HOME_SCREEN", params, {})
          .then((res) => {
            setWidgetsData(res.data.data);
            setHomeShimmer(false);
            res.data.data.forEach((item) => {
              let getWidgetData = () => {
                let params;
                if (item.widgetName === "banner_widget") {
                  params = {
                    pageId: "food",
                  };
                } else if (
                  item.widgetName === "product_list_widget" &&
                  (item.data.pageId?.toLowerCase().includes("trending") ||
                    item.data.pageId?.toLowerCase().includes("popular"))
                ) {
                  params = {
                    category: "FMCG",
                    filterCondition: "popular",
                    page: 0,
                  };
                  setTopSellShimmer(true);
                } else if (
                  item.widgetName === "product_list_widget" &&
                  (item.data.pageId?.toLowerCase().includes("new") ||
                    item.data.pageId?.toLowerCase().includes("newly"))
                ) {
                  params = {
                    category: "FMCG",
                    filterCondition: "new",
                    page: 0,
                  };
                  setNewlyAddShimmer(true);
                } else if (item.widgetName === "manufacturer_list_widget") {
                  params = {
                    category: "FMCG",
                  };
                  setManfShimmer(true);
                }

                if (
                  item &&
                  item.widgetName !== "vertical_product_list_widget"
                ) {
                  let api = common_product_widget(
                    item.data.apiEndPoint,
                    params,
                  );
                  api
                    .then((res) => {
                      if (item.widgetName === "offer_category_widget") {
                        setOffersWidget(res.data.data);
                      } else if (item.widgetName === "banner_widget") {
                        setBannerWidget(res.data.data);
                        localStorage.setItem(
                          "currentScreenBannerData",
                          JSON.stringify({ index: 1, data: res.data.data[0] }),
                        );
                        let arr = [];
                        res.data.data.forEach((ele, i) => {
                          arr.push(
                            <img
                              onClick={async () => {
                                Common_Event_Hit("DYNAMIC_EVENT", {
                                  eventName: "banner_tapped",
                                  screen_name:
                                    localStorage.getItem("currentScreen"),
                                });
                                setBannerData(ele);
                                navigate("/bannerRedirect");
                              }}
                              className="banner_img"
                              src={ele.url}
                              alt={i}
                            />,
                          );
                        });
                        setBannerImages(arr);
                      } else if (
                        item.widgetName === "product_list_widget" &&
                        (item.data.pageId?.toLowerCase().includes("trending") ||
                          item.data.pageId?.toLowerCase().includes("popular"))
                      ) {
                        setProductList(res.data.data);
                        setTopSellShimmer(false);
                      } else if (
                        item.widgetName === "product_list_widget" &&
                        (item.data.pageId?.toLowerCase().includes("new") ||
                          item.data.pageId?.toLowerCase().includes("newly"))
                      ) {
                        setProductListNew(res.data.data);
                        setNewlyAddShimmer(false);
                      } else if (
                        item.widgetName === "manufacturer_list_widget"
                      ) {
                        setManufacturers(res.data.data);
                        setManfShimmer(false);
                      }
                    })
                    .catch((error) => {
                      console.log(error);
                      if (error?.response?.status === 401) {
                        refreshToken().then((res) => {
                          getWidgetData();
                        });
                      } else if (
                        error?.response?.status === 502 ||
                        error?.response?.status === 503
                      ) {
                        setShowMaintenance({
                          status: true,
                          apiData: error?.response,
                        });
                      } else if (error?.response?.status === 500) {
                        setErrorModal({
                          show: true,
                          apiData: error?.response,
                          content: "Oops something went wrong !",
                          tryAgain: function () {
                            getWidgetData();
                          },
                        });
                      } else {
                        setErrorModal({
                          show: true,
                          apiData: error?.response,
                          content: error?.response?.data?.error?.error
                            ? error.response.data.error.error
                            : "Something went wrong!",
                          tryAgain: function () {
                            getWidgetData();
                          },
                        });
                      }
                    });
                }
              };

              return getWidgetData();
            });
          })
          .catch((error) => {
            if (error?.response?.status === 401) {
              refreshToken()
                .then((res) => {
                  schemes_screen();
                })
                .catch((error) => {
                  localStorage.removeItem("userData");
                  localStorage.removeItem("userAuth");
                  navigate("/login");
                });
            } else if (
              error?.response?.status === 502 ||
              error?.response?.status === 503 ||
              error?.response?.status === 504
            ) {
              setShowMaintenance({ status: true, apiData: error?.response });
            } else if (error?.response?.status === 500) {
              setErrorModal({
                show: true,
                apiData: error?.response,
                content: "Oops something went wrong !",
                tryAgain: function () {
                  schemes_screen();
                },
              });
            } else {
              setErrorModal({
                show: true,
                apiData: error?.response,
                content: error?.response?.data?.error?.error
                  ? error.response.data.error.error
                  : "Something went wrong!",
                tryAgain: function () {
                  schemes_screen();
                },
              });
            }
          });
      };
      schemes_screen();
      getManufacturers();
      getPopularProducts();
      getNewProducts();
      getSkuCount();
    } else {
      navigate("/home");
    }
  }, []);

  useEffect(() => {
    getAllProducts();
  }, [page]);

  return (
    <Fragment>
      <ErrorModal
        show={errorModal.show}
        content={errorModal.content}
        apiData={errorModal?.apiData}
        onHide={() => {
          setErrorModal({ show: false, content: "" });
        }}
        tryAgain={() => {
          errorModal?.tryAgain();
          setErrorModal({ show: false, content: "" });
        }}
      />
      <Container fluid className="productList">
        <Container fluid className="productListHeader font_ubuntu display_flex">
          <HiOutlineArrowNarrowLeft
            className="cursor_pointer goBack"
            onClick={() => navigate("/home")}
          />{" "}
          &nbsp;&nbsp;&nbsp;{" "}
          <div className="head_specialOffers">
            FMCG
            {skuData && (
              <span className="sub_head">
                {skuData.companyCount} Companies • {skuData.skuCount} SKU'S
              </span>
            )}
          </div>
        </Container>
        {homeShimmer && (
          <Container>
            <Fragment>
              <Container>
                <div className="skeletal_div animateShimmer"></div>
              </Container>
              <Container>
                <div className="skeletal_div animateShimmer"></div>
              </Container>
              <Container>
                <div className="skeletal_div animateShimmer"></div>
              </Container>
              <Container>
                <div className="skeletal_div animateShimmer"></div>
              </Container>
            </Fragment>
          </Container>
        )}
        <Container>
          {widgetsData &&
            widgetsData.map((widget, i) => {
              if (widget.widgetName === "manufacturer_list_widget") {
                return (
                  <Container key={i}>
                    {manufShimmer && (
                      <Fragment>
                        <p
                          className=" font_18 font_weight_md font_ubuntu"
                          style={{ color: widget.data.titleColor }}>
                          {widget.data.title}
                        </p>
                        <CompaniesSlider
                          shimmer={manufShimmer}
                          data={manufacturers}
                          scheme="food"
                          getProductListHeader={getProductListHeader}
                          footerColor={"#F4F6F8"}
                          id={"trendingProducts"}
                          darkColor={"#4B4495"}
                          lightColor={"#a49cf598"}
                        />
                      </Fragment>
                    )}
                    {manufacturers && manufacturers.length > 0 && (
                      <Fragment>
                        <p
                          className=" font_18 font_weight_md font_ubuntu"
                          style={{ color: widget.data.titleColor }}>
                          {widget.data.title}
                        </p>
                        <CompaniesSlider
                          data={manufacturers}
                          scheme="food"
                          getProductListHeader={getProductListHeader}
                          footerColor={"#F4F6F8"}
                          id={"trendingProducts"}
                          darkColor={"#4B4495"}
                          lightColor={"#a49cf598"}
                        />
                      </Fragment>
                    )}
                  </Container>
                );
              } else if (widget.widgetName === "banner_widget") {
                return (
                  bannerWidget?.length > 0 && (
                    <>
                      <br></br>
                      <Container fluid className="web_carousel">
                        <div className="banner_section">
                          <BannerSlider
                            slides={bannerImages}
                            slideChange={homeBannerSlide}
                          />
                        </div>
                      </Container>

                      <Carousel
                        className="banner_section mobile_carousel"
                        onSlide={homeBannerSlide}>
                        {bannerWidget.map((ele, ind) => (
                          <Carousel.Item key={ind}>
                            <div
                              onClick={async () => {
                                Common_Event_Hit("DYNAMIC_EVENT", {
                                  eventName: "banner_tapped",
                                  screen_name:
                                    localStorage.getItem("currentScreen"),
                                });
                                setBannerData(ele);
                                navigate("/bannerRedirect");
                              }}>
                              <img
                                className="d-block banner_img"
                                src={ele.url}
                                alt={ele.fileName}
                              />
                            </div>
                          </Carousel.Item>
                        ))}
                      </Carousel>
                    </>
                  )
                );
              } else if (
                widget.widgetName === "product_list_widget" &&
                (widget.data.pageId?.toLowerCase().includes("trending") ||
                  widget.data.pageId?.toLowerCase().includes("popular"))
              ) {
                return (
                  <>
                    {topSellShimmer && (
                      <Container>
                        <br></br>
                        <p
                          className="font_18 font_weight_md font_ubuntu"
                          style={{ color: widget.data.titleColor }}>
                          {widget.data.title}
                        </p>
                        <Slider
                          shimmer={topSellShimmer}
                          screen={"food_screen"}
                          widgetData={widget}
                          ProductRes={productList}
                          footerColor={"#F4F6F8"}
                          id={"foodPopular"}
                          darkColor={"#4B4495"}
                          lightColor={"#a49cf598"}
                        />
                      </Container>
                    )}
                    {productList && (
                      <Container>
                        <br></br>
                        <p
                          className=" font_18 font_weight_md font_ubuntu"
                          style={{ color: widget.data.titleColor }}>
                          {widget.data.title}
                        </p>
                        <Slider
                          screen={"food_screen"}
                          widgetData={widget}
                          ProductRes={productList}
                          footerColor={"#F4F6F8"}
                          id={"foodPopular"}
                          darkColor={"#4B4495"}
                          lightColor={"#a49cf598"}
                        />
                      </Container>
                    )}
                  </>
                );
              } else if (
                widget.widgetName === "product_list_widget" &&
                (widget.data.pageId?.toLowerCase().includes("new") ||
                  widget.data.pageId?.toLowerCase().includes("newly"))
              ) {
                return (
                  <>
                    {newlyAddShimmer && (
                      <Container>
                        <br></br>
                        <p
                          className="font_18 font_weight_md font_ubuntu"
                          style={{ color: widget.data.titleColor }}>
                          {widget.data.title}
                        </p>
                        <Slider
                          shimmer={newlyAddShimmer}
                          screen={"food_screen"}
                          widgetData={widget}
                          ProductRes={productListNew}
                          footerColor={"#F4F6F8"}
                          id={"foodNew"}
                          darkColor={"#4B4495"}
                          lightColor={"#a49cf598"}
                        />
                      </Container>
                    )}
                    {productListNew && (
                      <Container>
                        <br></br>
                        <p
                          className="font_18 font_weight_md font_ubuntu"
                          style={{ color: widget.data.titleColor }}>
                          {widget.data.title}
                        </p>
                        <Slider
                          screen={"food_screen"}
                          widgetData={widget}
                          ProductRes={productListNew}
                          footerColor={"#F4F6F8"}
                          id={"foodNew"}
                          darkColor={"#4B4495"}
                          lightColor={"#a49cf598"}
                        />
                      </Container>
                    )}
                  </>
                );
              }
            })}

          {/* Top Companies */}
          {(manufShimmer || (manufacturers && manufacturers.length > 0)) && (
            <Container>
              <p className="font_18 font_weight_md font_ubuntu">
                Top FMCG Companies
              </p>
              <CompaniesSlider
                shimmer={manufShimmer}
                data={manufacturers}
                scheme="food"
                getProductListHeader={getProductListHeader}
                footerColor={"#F4F6F8"}
                id={"fmcgCompanies"}
                darkColor={"#4B4495"}
                lightColor={"#a49cf598"}
              />
            </Container>
          )}

          {/* Top Selling */}
          {topSellShimmer && (
            <Container>
              <br></br>
              <p className="font_18 font_weight_md font_ubuntu">
                Top Selling FMCG
              </p>
              <Slider
                shimmer={true}
                screen={"food_screen"}
                footerColor={"#F4F6F8"}
                id={"fmcgPopularShimmer"}
                darkColor={"#4B4495"}
                lightColor={"#a49cf598"}
              />
            </Container>
          )}
          {!topSellShimmer &&
            productList?.medicinesResponsesList?.length > 0 && (
              <Container>
                <br></br>
                <p className="font_18 font_weight_md font_ubuntu">
                  Top Selling FMCG
                </p>
                <Slider
                  screen={"food_screen"}
                  ProductRes={productList}
                  footerColor={"#F4F6F8"}
                  id={"fmcgPopular"}
                  darkColor={"#4B4495"}
                  lightColor={"#a49cf598"}
                />
              </Container>
            )}

          {/* Newly Added */}
          {newlyAddShimmer && (
            <Container>
              <br></br>
              <p className="font_18 font_weight_md font_ubuntu">
                Newly Added FMCG
              </p>
              <Slider
                shimmer={true}
                screen={"food_screen"}
                footerColor={"#F4F6F8"}
                id={"fmcgNewShimmer"}
                darkColor={"#4B4495"}
                lightColor={"#a49cf598"}
              />
            </Container>
          )}
          {!newlyAddShimmer &&
            productListNew?.medicinesResponsesList?.length > 0 && (
              <Container>
                <br></br>
                <p className="font_18 font_weight_md font_ubuntu">
                  Newly Added FMCG
                </p>
                <Slider
                  screen={"food_screen"}
                  ProductRes={productListNew}
                  footerColor={"#F4F6F8"}
                  id={"fmcgNew"}
                  darkColor={"#4B4495"}
                  lightColor={"#a49cf598"}
                />
              </Container>
            )}

          {allShimmer && (
            <Fragment>
              <Container>
                <br></br>
                <p className="font_18 font_weight_md font_ubuntu">
                  All FMCG Products
                </p>
              </Container>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                }}>
                <ProductCard2 shimmer={allShimmer} />{" "}
                <ProductCard2 shimmer={allShimmer} />{" "}
                <ProductCard2 shimmer={allShimmer} />{" "}
                <ProductCard2 shimmer={allShimmer} />
              </div>
            </Fragment>
          )}
          {allProductList?.medicinesResponsesList?.length > 0 && (
            <Fragment>
              <Container>
                <br></br>
                <p className="font_18 font_weight_md font_ubuntu">
                  All FMCG Products
                </p>
              </Container>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                }}>
                <InfiniteScroll
                  dataLength={dataLength}
                  next={fetchMoreData}
                  hasMore={hasMore}
                  scrollThreshold="90%"
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                  }}
                  loader={<></>}>
                  {allProductList.medicinesResponsesList.map((med, index) => (
                    <ProductCard2
                      position={index}
                      screen={"food_screen"}
                      key={index}
                      medData={med}
                    />
                  ))}
                </InfiniteScroll>
              </div>
            </Fragment>
          )}
          {!allShimmer &&
            allProductList?.medicinesResponsesList?.length === 0 && (
              <Container className="no_data">
                No FMCG products are available at this moment
              </Container>
            )}
        </Container>
      </Container>
    </Fragment>
  );
};

export default React.memo(Fmcg);
